export default "images/vercel-logo.png";